import { cn } from '@/lib/utils'

/**
 * iOS 27 blurs the top of Home Screen apps; a solid fixed strip at the very
 * top makes it paint the status bar that colour instead (PB-78). Home Screen +
 * phone width only. Pass the page's background (`bg-background`, `bg-muted`)
 * so the status bar matches the page under it. Content that must stay whole
 * (the header's bell count) sits above it at `z-50`.
 */
export function StatusBarStrip({ className }: { className: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none fixed inset-x-0 top-0 z-40 hidden h-2 md:hidden [@media(display-mode:standalone)]:block [@media(display-mode:standalone)]:md:hidden',
        className
      )}
    />
  )
}
